import React, { useContext, useState } from "react";
import "./Menu.scss";
/* import Logo from "../../assets/images/logo.png"; */
/* import searchIcon from "../../assets/icons/search.svg";
import DownIcon from "../../assets/icons/down.svg";
import DotIcon from "../../assets/icons/dot.svg"; */
import { Link } from "react-router-dom";
import Logo from "../../assets/images/solucionarte_logo-16.png";
import UserContext from "../../Context/UserContext";

const Menu = ({ background, color }) => {

    const { user, setUser } = useContext(UserContext);
    const [ btnToggle, setBtnToggle ] = useState(false);

    const CerrarSesion = () => {
        localStorage.removeItem("token");
        setUser(null)
    }

    const handleClick = () => {
        setBtnToggle(!btnToggle);
    }

    window.addEventListener("resize", function(event) {
        if(window.innerWidth >= 1000) {
            setBtnToggle(false);
        }
    })

    window.onscroll = function() {
        setBtnToggle(false);
      };

    return (
        <div className="menu" style={{ backgroundColor: `${background}`, color: `${color}`, height: `${btnToggle ? "auto" : "80px"}`, borderBottom: `${btnToggle ? "1px solid white" : "none" }` }}>

            <Link className="menu__logo" to="/">
                <img src={Logo} alt="Solucionarte" />
            </Link>

            <div className="menu__links">
                <Link className="menu__link" exact to="/prestadores">Prestadores</Link>
                <Link className="menu__link" exact to="/quiénes-somos">Quiénes somos</Link>
                <Link className="menu__link" to={{
                    pathname: "prestadores", state: { emergency: true }
                }}>Emergencia</Link>

            </div>

            <div className="menu__login">
                {
                    user
                        ?
                        <>
                            <Link className="menu__login-text" exact to="/#">Mi perfil</Link>
                            &nbsp;
                            <Link className="menu__login-text" exact to="/" onClick={() => CerrarSesion()}>Cerrar Sesión</Link>
                        </>

                        : <Link className="menu__login-text" exact to="/login">Iniciar Sesión</Link>
                }

            </div>

            <div className="menu__bars" onClick={handleClick}>
                <i class="fas fa-bars"></i>
            </div>
        </div >
    )
}

export default Menu;
